import * as React from "react";
const ErrorSmall = ({ size, ...props }) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 20 20", fill: "currentColor", width: size || "20", height: size || "20", ...props }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", d: "M9.5,3 C13.084,3 16,5.916 16,9.5 C16,13.084 13.084,16 9.5,16 C5.916,16 3,13.084 3,9.5 C3,5.916 5.916,3 9.5,3 Z M9.5,4 C6.467,4 4,6.467 4,9.5 C4,12.533 6.467,15 9.5,15 C12.533,15 15,12.533 15,9.5 C15,6.467 12.533,4 9.5,4 Z M10,11 L10,12 L9,12 L9,11 L10,11 Z M10,7 L10,10 L9,10 L9,7 L10,7 Z" }));
ErrorSmall.displayName = "ErrorSmall";
var ErrorSmall_default = ErrorSmall;
export {
  ErrorSmall_default as default
};
